import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id = 0,
    name,
    desc,
    remarkEnable = false,
    auditEnable = false,
    permEnable = false,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.das.utable.save, {
        id,
        name,
        desc,
        remarkEnable,
        auditEnable,
        permEnable,
    }, options);
    if (error) return { error, status };
    return content || {};
};
